module.exports =
  special: [
    ['US', 'united-states']
    ['GB', 'united-kingdom']
    ['CA', 'canada']
    ['AU', 'australia']
    ['DE', 'germany']
    ['NL', 'netherlands']
  ]
  unloved: [
    ['AF', 'afghanistan']
    ['AL', 'albania']
    ['DZ', 'algeria']
    ['AS', 'american-samoa']
    ['AD', 'andorra']
    ['AI', 'anguilla']
    ['AG', 'antiqua-and-barbuda']
    ['AR', 'argentina']
    ['AM', 'armenia']
    ['AW', 'aruba']
    ['AU', 'australia']
    ['AT', 'austria']
    ['AZ', 'azerbaijan']
    ['BS', 'bahamas']
    ['BH', 'bahrain']
    ['BD', 'bangladesh']
    ['BB', 'barbados']
    ['BY', 'belarus']
    ['BE', 'belgium']
    ['BZ', 'belize']
    ['BJ', 'benin']
    ['BM', 'bermuda']
    ['BT', 'bhutan']
    ['BO', 'bolivia']
    ['BA', 'bosnia-herzegovina']
    ['BV', 'bouvet-islands']
    ['BR', 'brazil']
    ['IO', 'british-indian-ocean-territory']
    ['VG', 'british-virgin-islands']
    ['BN', 'brunei']
    ['BG', 'bulgaria']
    ['BF', 'burkina-faso']
    ['BI', 'burundi']
    ['KH', 'cambodia']
    ['CM', 'cameroon']
    ['CA', 'canada']
    ['IC', 'canary-islands']
    ['CV', 'cape-verde']
    ['KY', 'cayman-islands']
    ['CF', 'central-african-republic']
    ['TD', 'chad']
    ['CL', 'chile']
    ['CN', 'china']
    ['CO', 'colombia']
    ['KM', 'comoros']
    ['CG', 'congo']
    ['CR', 'costa-rica']
    ['CI', 'cote-d-ivoire']
    ['HR', 'croatia']
    ['CY', 'cyprus']
    ['CZ', 'czech-republic']
    ['DK', 'denmark']
    ['DJ', 'djibouti']
    ['DM', 'dominica']
    ['DO', 'dominican-republic']
    ['EG', 'egypt']
    ['SV', 'el-salvador']
    ['EC', 'equador']
    ['GQ', 'equatorial-guinea']
    ['ER', 'eritrea']
    ['EE', 'estonia']
    ['ET', 'ethiopia']
    ['FK', 'falkland-islands']
    ['FO', 'faroe-islands']
    ['FM', 'federated-states-of-micronesia']
    ['FJ', 'fiji']
    ['FI', 'finland']
    ['FR', 'france']
    ['GF', 'french-guiana']
    ['PF', 'french-polynesia']
    ['GA', 'gabon']
    ['GM', 'gambia']
    ['GE', 'georgia']
    ['DE', 'germany']
    ['GH', 'ghana']
    ['GI', 'gibraltar']
    ['GR', 'greece']
    ['GL', 'greenland']
    ['GD', 'grenada']
    ['GP', 'guadeloupe']
    ['GU', 'guam']
    ['GT', 'guatemala']
    ['GG', 'guernsey']
    ['GN', 'guinea']
    ['GW', 'guinea-bissau']
    ['GY', 'guyana']
    ['HT', 'haiti']
    ['HN', 'honduras']
    ['HK', 'hong-kong']
    ['HU', 'hungary']
    ['IS', 'iceland']
    ['IN', 'india']
    ['ID', 'indonesia']
    ['IE', 'ireland']
    ['IL', 'israel']
    ['IT', 'italy']
    ['JM', 'jamaica']
    ['JP', 'japan']
    ['JE', 'jersey']
    ['JO', 'jordan']
    ['KZ', 'kazakhstan']
    ['KE', 'kenya']
    ['KI', 'kiribati']
    ['KW', 'kuwait']
    ['KG', 'kyrgyzstan']
    ['LA', 'laos']
    ['LV', 'latvia']
    ['LB', 'lebanon']
    ['LS', 'lesotho']
    ['LR', 'liberia']
    ['LI', 'liechtenstein']
    ['LT', 'lithuania']
    ['LU', 'luxembourg']
    ['MO', 'macau']
    ['MG', 'madagascar']
    ['MW', 'malawi']
    ['MY', 'malaysia']
    ['MV', 'maldives']
    ['ML', 'mali']
    ['MT', 'malta']
    ['MH', 'marshall-islands']
    ['MQ', 'martinique']
    ['MR', 'mauritania']
    ['MU', 'mauritius']
    ['YT', 'mayotte']
    ['MX', 'mexico']
    ['MD', 'moldova']
    ['MN', 'mongolia']
    ['ME', 'montenegro']
    ['MA', 'morocco']
    ['MZ', 'mozambique']
    ['MM', 'myanmar']
    ['NA', 'namibia']
    ['NR', 'nauru']
    ['NP', 'nepal']
    ['AN', 'netherlands-antilles']
    ['NL', 'netherlands']
    ['NC', 'new-caledonia']
    ['NZ', 'new-zealand']
    ['NI', 'nicaragua']
    ['NE', 'niger']
    ['NG', 'nigeria']
    ['MP', 'northern-mariana-islands']
    ['NO', 'norway']
    ['OM', 'oman']
    ['PK', 'pakistan']
    ['PW', 'palau']
    ['PA', 'panama']
    ['PG', 'papua-new-guinea']
    ['PY', 'paraguay']
    ['PE', 'peru']
    ['PH', 'philippines']
    ['PN', 'pitcairn']
    ['PL', 'poland']
    ['PT', 'portugal']
    ['PR', 'puerto-rico']
    ['QA', 'qatar']
    ['KR', 'republic-of-korea']
    ['RE', 'reunion']
    ['RO', 'romania']
    ['RU', 'russia']
    ['ST', 'sao-tome-and-principe']
    ['SA', 'saudi-arabia']
    ['SN', 'senegal']
    ['RS', 'serbia']
    ['SC', 'seychelles']
    ['SL', 'sierra-leone']
    ['SG', 'singapore']
    ['SK', 'slovakia']
    ['SI', 'slovenia']
    ['SB', 'solomon-islands']
    ['SO', 'somalia']
    ['ZA', 'south-africa']
    ['ES', 'spain']
    ['LK', 'sri-lanka']
    ['SH', 'st-helena']
    ['KN', 'st-kitts-and-nevis']
    ['LC', 'st-lucia']
    ['VC', 'st-vincent-and-the-grenadines']
    ['SD', 'sudan']
    ['SR', 'suriname']
    ['SJ', 'svalbard-and-jan-mayen-islands']
    ['SZ', 'swaziland']
    ['SE', 'sweden']
    ['CH', 'switzerland']
    ['SY', 'syria']
    ['TW', 'taiwan']
    ['TJ', 'tajikistan']
    ['TZ', 'tanzania']
    ['TH', 'thailand']
    ['MK', 'the-former-yugoslav-republic-of-macedonia']
    ['TG', 'togo']
    ['TO', 'tonga']
    ['TT', 'trinidad-and-tobago']
    ['TN', 'tunisia']
    ['TR', 'turkey']
    ['TM', 'turkmenistan']
    ['TC', 'turks-and-caicos-islands']
    ['TV', 'tuvalu']
    ['UG', 'uganda']
    ['UA', 'ukraine']
    ['AE', 'united-arab-emirates']
    ['GB', 'united-kingdom']
    ['US', 'united-states']
    ['UY', 'uruguay']
    ['UZ', 'uzbekistan']
    ['VU', 'vanuatu']
    ['VA', 'vatican-city']
    ['VE', 'venezuela']
    ['VN', 'vietnam']
    ['EH', 'western-sahara']
    ['YE', 'yemen']
    ['CD', 'zaire']
    ['ZM', 'zambia']
    ['ZW', 'zimbabwe']
  ]



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/internal/countries.coffee